import React, { useRef } from 'react';
import { Typography } from 'antd';
import { useTranslation } from 'react-i18next';
import { debounce } from 'lodash';
import { supabase } from '../supabaseClient';
import { message } from 'antd';

const NotesTab = ({ meetingId, userId, initialNotes }) => {
    const [meetingNotes, setMeetingNotes] = React.useState(initialNotes);
    const [isSavingNotes, setIsSavingNotes] = React.useState(false);
    const { t } = useTranslation();

    const debouncedSaveNotes = useRef(
        debounce(async (content) => {
            try {
                setIsSavingNotes(true);

                const { data, error } = await supabase
                    .from('meeting_notes')
                    .upsert({
                        meeting_id: meetingId,
                        content: content,
                        user_id: userId,
                        updated_at: new Date().toISOString()
                    }, {
                        onConflict: 'meeting_id',
                        returning: 'minimal'
                    });

                if (error) throw error;
                message.success(t('Notes saved successfully'));
            } catch (error) {
                console.error('Error saving notes:', error);
                message.error(t('Failed to save notes'));
            } finally {
                setIsSavingNotes(false);
            }
        }, 1000)
    ).current;

    return (
        <div style={{ position: 'relative' }}>
            <textarea
                value={meetingNotes}
                onChange={(e) => {
                    setMeetingNotes(e.target.value);
                    debouncedSaveNotes(e.target.value);
                }}
                style={{
                    width: '100%',
                    minHeight: '500px',
                    padding: '16px',
                    backgroundColor: '#fff',
                    borderRadius: '4px',
                    border: '1px solid #d9d9d9',
                    lineHeight: '1.6',
                    resize: 'vertical',
                    fontFamily: 'inherit',
                    fontSize: 'inherit'
                }}
            />
            {isSavingNotes && (
                <Typography.Text type="secondary" style={{ position: 'absolute', right: 8, bottom: 8 }}>
                    {t("Saving...")}
                </Typography.Text>
            )}
        </div>
    );
};

export default NotesTab;